import * as Yup from 'yup';

export const excludedInitialValues = {
    description: '',
    startDate: null,
    endDate: null,
    amount: '',
    bankAccount: 'all',
    type: { value: 'all', label: 'All' },
    excludedBy: { value: 'all', label: 'All Users' },
};

export const excludedSchema = Yup.object({
    endDate: Yup.date().nullable(),
    amount: Yup.number().nullable(),
    startDate: Yup.date().nullable(),
    description: Yup.string().nullable(),
    bankAccount: Yup.string().nullable(),
    type: Yup.object()
        .shape({
            value: Yup.string().required('Type value is required'),
            label: Yup.string().required('Type label is required'),
        })
        .nullable(),
    excludedBy: Yup.object()
        .shape({
            value: Yup.string().required('Excluded by value is required'),
            label: Yup.string().required('Excluded by label is required'),
        })
        .nullable(),
});
